const next = document.getElementById('next_opt');
const prev = document.getElementById('prev_opt');
const swiper = document.getElementById('items_opt');
const swiperItem = document.getElementById('item_opt');
const main = document.getElementById('main-swiper_opt');
const swiperItemWidth = swiperItem.getBoundingClientRect().width;

let isDown = false;
let scrollLeft;
let startX;


function showHideButtons() {

    const swiperWidth = swiper.scrollWidth;
    const mainWidth = main.getBoundingClientRect().width;

    if (swiperWidth > mainWidth) {

        if (swiper.clientWidth + swiper.scrollLeft >= swiper.scrollWidth - 2) {
            next.style.visibility = "visible";
        }
        else if (swiper.clientWidth - swiper.scrollLeft >= swiper.clientWidth - 2) {
            prev.style.visibility = "visible";
        }
        else {
            next.style.visibility = "visible";
            prev.style.visibility = "visible";
        }
        swiper.style.justifyContent = "start";
    }
    else {
        swiper.style.justifyContent = "center";
    }
}

window.addEventListener('resize', showHideButtons);
onload = showHideButtons();


swiper.addEventListener('scroll', () => {
    showHideButtons();
});

swiper.addEventListener('mousedown', (e) => {
    isDown = true;
    swiper.classList.add('active');
    startX = e.pageX - swiper.offsetLeft;
    scrollLeft = swiper.scrollLeft;
});

swiper.addEventListener('mouseleave', () => {
    isDown = false;
    swiper.classList.remove('active');
});

swiper.addEventListener('mouseup', () => {
    isDown = false;
    swiper.classList.remove('active');
});

swiper.addEventListener('mousemove', (e) => {
    if (!isDown) return;
    e.preventDefault();
    const x = e.pageX - swiper.offsetLeft;
    const walk = (x - startX);
    swiper.scrollLeft = scrollLeft - walk;
});

prev.addEventListener('click', (e) => {
    startX = e.pageX - swiper.offsetLeft;
    swiper.scrollLeft -= swiperItemWidth * 2;
});

next.addEventListener('click', (e) => {
    startX = e.pageX - swiper.offsetLeft;
    swiper.scrollLeft += swiperItemWidth * 2;
});


/* Second Slider */
const next1 = document.getElementById('next_sun');
const prev1 = document.getElementById('prev_sun');
const swiper1 = document.getElementById('items_sun');
const swiperItem1 = document.getElementById('item_sun');
const main1 = document.getElementById('main-swiper_sun');
const swiperItemWidth1 = swiperItem1.getBoundingClientRect().width;

let isDown1 = false;

let startX1;

function showHideButtons1() {

    const swiperWidth = swiper1.scrollWidth;
    const mainWidth = main1.getBoundingClientRect().width;

    if (swiperWidth > mainWidth) {

        if (swiper1.clientWidth + swiper1.scrollLeft >= swiper1.scrollWidth - 2) {
            next1.style.visibility = "visible";
        }
        else if (swiper1.clientWidth - swiper1.scrollLeft >= swiper1.clientWidth - 2) {
            prev1.style.visibility = "visible";
        }
        else {
            next1.style.visibility = "visible";
            prev1.style.visibility = "visible";
        }
        swiper1.style.justifyContent = "start";
    }
    else {
        swiper1.style.justifyContent = "center";
    }
}

window.addEventListener('resize', showHideButtons1);
onload = showHideButtons1();

swiper1.addEventListener('scroll', () => {
    showHideButtons1();
});

swiper1.addEventListener('mousedown', (e) => {
    isDown1 = true;
    swiper1.classList.add('active');
    startX1 = e.pageX - swiper1.offsetLeft;
    scrollLeft = swiper1.scrollLeft;
});

swiper1.addEventListener('mouseleave', () => {
    isDown1 = false;
    swiper1.classList.remove('active');
});

swiper1.addEventListener('mouseup', () => {
    isDown1 = false;
    swiper1.classList.remove('active');
});

swiper1.addEventListener('mousemove', (e) => {
    if (!isDown1) return;
    e.preventDefault();
    const x = e.pageX - swiper1.offsetLeft;
    const walk = (x - startX1);
    swiper1.scrollLeft = scrollLeft - walk;
});

prev1.addEventListener('click', (e) => {
    startX1 = e.pageX - swiper1.offsetLeft;
    swiper1.scrollLeft -= swiperItemWidth1 * 2;
});

next1.addEventListener('click', (e) => {  
    startX1 = e.pageX - swiper1.offsetLeft;
    swiper1.scrollLeft += swiperItemWidth1 * 2;
});